"use client";

import React from "react";
import Link from "next/link"; // Using Next.js Link
import "./StaffAugmentation.css";
import { Image } from "react-bootstrap";

export default function StaffAugmentationPage() {
  return (
    <>
      <div>
        <section>
          <div className="container py-5">
            <div className="row align-items-center">
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="0">
                <h1 className="heading">
                  Staff Augmentation by <br /> CodeQlik
                </h1>
                <p className="mt-3 top-banner-text">
                  {`In today's competitive tech landscape, scaling your
                  development team efficiently is essential for staying ahead.
                  At CodeQlik, we offer flexible Staff Augmentation services
                  that empower businesses to rapidly expand their development
                  capabilities without the overhead of hiring full-time
                  employees. Whether you need short-term specialists or
                  long-term dedicated teams, we provide access to top-tier
                  talent, ensuring your projects are delivered on time and
                  within budget.`}
                </p>
                <div className="mt-3">
                  <button className="btn btn-customA">Dedicated Teams</button>
                  <button className="btn btn-customA">
                    Skill-Based Augmentation
                  </button>
                  <button className="btn btn-customA">
                    Long-Term Staff Augmentation
                  </button>
                  <button className="btn btn-customA">
                    Short-Term Staff Augmentation
                  </button>
                  <button className="btn btn-customA">Hybrid Model</button>
                  <button className="btn btn-customA">
                    Project-Based Augmentation
                  </button>
                </div>
              </div>
              <div
                className="col-md-6 mt-6 text-center illustration"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <Image
                  src="/assets/img/Group-staff-banner.svg"
                  alt="CodeQlik Staff Augmentation Banner Illustration"
                />
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5">
            <div className="row align-items-center">
              <div
                className="col-md-5 mt-6 text-center illustrationA order-2 order-md-1"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <Image src="/assets/img/Frame_2_.svg" alt="Why Choose Staff Augmentation Illustration" />
              </div>
              <div className="col-md-7 order-1 order-md-2" data-aos="fade-up" data-aos-delay="0">
                <h2 className="heading">Why Choose Staff Augmentation?</h2>
                <ul className="mt-3">
                  <li className="choose-text">
                    <strong>Access to Specialized Talent:</strong>
                    <p className="chosse-staff-text">
                      Gain immediate access to a global network of experienced
                      developers, engineers, and IT specialists.
                    </p>{" "}
                  </li>
                  <li className="choose-text">
                    <strong>Scalability:</strong>
                    <p className="chosse-staff-text">
                      Quickly scale your team up or down based on your project
                      needs, avoiding the delays and costs of traditional
                      hiring.
                    </p>{" "}
                  </li>
                  <li className="choose-text">
                    <strong>Cost-Effective:</strong>{" "}
                    <p className="chosse-staff-text">
                      Reduce the overhead of full-time hires and only pay for
                      the skills you need, when you need them.
                    </p>{" "}
                  </li>
                  <li className="choose-text">
                    <strong>Control & Flexibility:</strong>
                    <p className="chosse-staff-text">
                      Maintain full control over your project, while our experts
                      integrate seamlessly with your in-house team.
                    </p>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5" data-aos="fade-up" data-aos-delay="0">
            <h2 className="heading mb-4">How We Work</h2>
            <div className="row g-4">
              <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
                <div className="work-box h-100">
                  <div className="work-number">01</div>
                  <h5 className="mt-2 work-number-header">
                    <strong>Tailored Solutions</strong>
                  </h5>
                  <p className="work-number-text">
                    We assess your project needs and match you with specialists
                    who have the exact skills required for success.
                  </p>
                </div>
              </div>
              <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
                <div className="work-box h-100">
                  <div className="work-number">02</div>
                  <h5 className="mt-2 work-number-header">
                    <strong>Seamless Integration</strong>
                  </h5>
                  <p className="work-number-text">
                    Our experts integrate into your team, aligning with your
                    processes, tools, and goals for smooth collaboration.
                  </p>
                </div>
              </div>
              <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
                <div className="work-box h-100">
                  <div className="work-number">03</div>
                  <h5 className="mt-2 work-number-header">
                    <strong>Full Transparency</strong>
                  </h5>
                  <p className="work-number-text">
                    You retain control over project management while ensuring
                    the right talent to achieve your goals.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5" data-aos="fade-up" data-aos-delay="0">
            <h2 className="heading mb-4">
              Types of Staff Augmentation Services
            </h2>
            <div className="row g-4">
              <div
                className="col-lg-3 col-md-6 col-sm-6"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <div className="service-box h-100">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <span className="service-icon-staff flex-shrink-0">✔</span>
                    <h5 className="service-title-staff mb-0">Dedicated Teams</h5>
                  </div>
                  <p className="work-number-text">
                    Full teams of developers, designers, and engineers focused
                    solely on your project.
                  </p>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="service-box h-100">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <span className="service-icon-staff flex-shrink-0">✔</span>
                    <h5 className="service-title-staff mb-0">
                      Skill-Based Augmentation
                    </h5>
                  </div>
                  <p className="work-number-text">
                    Specialists in emerging technologies like AI, Machine
                    Learning, Cloud, and Blockchain.
                  </p>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-6"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <div className="service-box h-100">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <span className="service-icon-staff flex-shrink-0">✔</span>
                    <h5 className="service-title-staff mb-0">Short-Term Contracts</h5>
                  </div>
                  <p className="work-number-text">
                    On-demand talent to help meet tight deadlines or tackle
                    specific project phases.
                  </p>
                </div>
              </div>
              <div
                className=" col-lg-3 col-md-6 col-sm-6"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <div className="service-box h-100">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <span className="service-icon-staff flex-shrink-0">✔</span>
                    <h5 className="service-title-staff mb-0">
                      Long-Term Engagements
                    </h5>
                  </div>
                  <p className="work-number-text">
                    Augment your team with highly skilled professionals for
                    ongoing projects.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container py-5" data-aos="fade-up" data-aos-delay="0">
            <h2 className="section-titleA mb-3">Technologies We Support</h2>
            <p className="text-center">
              Our experts are proficient in a wide range of technologies,
              ensuring that you have the right skills for any project. Here’s a
              snapshot of the technologies we support:
            </p>
            <div className="row g-4">
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="tech-box-career">
                     <h4 className="category-title">Backend</h4>

                     <p className="tech-title">Java</p>
                     <span className="tech-pill">SE 8/11</span>
                     <span className="tech-pill">Spring</span>
                     <span className="tech-pill">Spring Boot</span>
                     <span className="tech-pill">Hibernate</span>
                     <span className="tech-pill">Liquibase</span>

                     <p className="tech-title">Python</p>
                     <span className="tech-pill">Django</span>
                     <span className="tech-pill">Flask</span>
                     <span className="tech-pill">Pyramid</span>
                     <span className="tech-pill">FastAPI</span>
                     <span className="tech-pill">Asyncio</span>

                     <p className="tech-title">C#</p>
                     <span className="tech-pill">ASP.NET Core/EF</span>
                     <span className="tech-pill">MediatR</span>
                     <span className="tech-pill">AutoMapper</span>
                     <span className="tech-pill">Serilog/XUnit</span>
                     <span className="tech-pill">Moq</span>

                     <p className="tech-title">PHP</p>
                     <span className="tech-pill">Laravel</span>
                     <span className="tech-pill">Symfony</span>
                     <span className="tech-pill">Yii2</span>
                     <span className="tech-pill">Bitrix</span>

                     <p className="tech-title">Go</p>
                     <span className="tech-pill">Revel</span>
                     <span className="tech-pill">Beego</span>
                     <span className="tech-pill">Gin</span>
                     <span className="tech-pill">Buffalo</span>
                     <span className="tech-pill">Kit</span>
                     <span className="tech-pill">Echo</span>

                     <p className="tech-title">Ruby</p>
                     <span className="tech-pill">Ruby on Rails</span>
                     <span className="tech-pill">Sinatra</span>
                     <span className="tech-pill">Hanami (Lotus)</span>

                     <p className="tech-title">C++</p>
                     <span className="tech-pill">CRYEngine</span>
                     <span className="tech-pill">LumberYard</span>
                     <span className="tech-pill">UE4</span>
                     <span className="tech-pill">Tensorflow</span>
                     <span className="tech-pill">Pytorch</span>
                     <span className="tech-pill">Geometric tools</span>
                     <span className="tech-pill">Cgal</span>
                     <span className="tech-pill">MeshLabDDS/MQTT</span>
                     <span className="tech-pill">TCP</span>
                     <span className="tech-pill">UDP</span>
                     <span className="tech-pill">POCO</span>
                     <span className="tech-pill">OSP</span>
                     <span className="tech-pill">Linux</span>
                     <span className="tech-pill">Windows</span>
                     <span className="tech-pill">VXWorks</span>

                     <p className="tech-title">DB</p>
                     <span className="tech-pill">PostgreSQL</span>
                     <span className="tech-pill">Oracle</span>
                     <span className="tech-pill">MS SQL</span>
                     <span className="tech-pill">MongoDB</span>
                     <span className="tech-pill">Redis</span>
                     <span className="tech-pill">Elasticsearch</span>


                  </div>
              </div>
              <div className=" col-md-6" data-aos="fade-up" data-aos-delay="0">
                <div className="row">
                  <div
                    className="col-md-12"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <div className="tech-box-career">
                      <h5 className="category-title">Frontend</h5>
                      <span className="tech-pill">JavaScript</span>
                      <span className="tech-pill">TypeScript</span>
                      <span className="tech-pill">React</span>
                      <span className="tech-pill">Redux</span>
                      <span className="tech-pill">Vue.js</span>
                      <span className="tech-pill">Angular</span>
                      <span className="tech-pill">Node.js</span>
                      <span className="tech-pill">Next.js</span>
                      <span className="tech-pill">Docker</span>
                    </div>
                  </div>
                  <div
                    className="col-md-12 mt-5"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <div className="tech-box-career">
                      <h5 className="category-title">Mobile</h5>
                      <span className="tech-pill">iOS</span>
                      <span className="tech-pill">Swift</span>
                      <span className="tech-pill">CoreData</span>
                      <span className="tech-pill">RxSwift</span>
                      <span className="tech-pill">Android</span>
                      <span className="tech-pill">Kotlin</span>
                      <span className="tech-pill">MVVM</span>
                      <span className="tech-pill">Retrofit</span>
                      <span className="tech-pill">Flutter</span>
                      <span className="tech-pill">React Native</span>
                    </div>
                  </div>
                  <div
                    className="col-md-12 mt-5"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <div className="tech-box-career">
                      <h5 className="category-title">QA</h5>
                      <span className="tech-pill">Selenium</span>
                      <span className="tech-pill">Postman</span>
                      <span className="tech-pill">Swagger</span>
                      <span className="tech-pill">JMeter</span>
                      <span className="tech-pill">TestRail</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
                <div className="tech-box-career">
                  <h5 className="category-title">DevOps</h5>
                  <span className="tech-pill">Kubernetes</span>
                  <span className="tech-pill">Terraform</span>
                  <span className="tech-pill">Ansible</span>
                  <span className="tech-pill">Jenkins</span>
                  <span className="tech-pill">Docker</span>
                </div>
              </div>
              <div className="col-md-6" data-aos="fade-up" data-aos-delay="200">
                <div className="tech-box-career">
                  <h5 className="category-title">Other</h5>
                  <span className="tech-pill">REST</span>
                  <span className="tech-pill">SOAP</span>
                  <span className="tech-pill">GraphQL</span>
                  <span className="tech-pill">JSON</span>
                  <span className="tech-pill">CI/CD</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-md-6 text-center stuff-img order-2 order-md-1"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <Image src="/assets/img/stuff-3.svg" alt="Staff Augmentation Trends 2024 Illustration" />
              </div>
              <div className="col-md-6 order-1 order-md-2" data-aos="fade-up" data-aos-delay="0">
                <h2 className="titleA">Staff Augmentation Trends in 2024</h2>
                <div className="underlineA"></div>
                <ul className="contentA">
                  <li>
                    <strong>Remote Teams:</strong>{" "}
                    <span className="content-text">
                      As remote work continues to dominate, we provide globally
                      distributed teams with overlapping time zones for
                      real-time collaboration.
                    </span>{" "}
                  </li>
                  <li>
                    <strong>AI-Powered Development:</strong>{" "}
                    <span className="content-text">
                      {" "}
                      Integrating AI to streamline workflows, optimize
                      development cycles, and automate repetitive tasks.
                    </span>
                  </li>
                  <li>
                    <strong>Cloud-Native Expertise:</strong>{" "}
                    <span className="content-text">
                      Growing demand for cloud-native architectures and
                      serverless solutions, especially in SaaS and e-commerce.
                    </span>{" "}
                  </li>
                  <li>
                    <strong>Sustainability in Tech:</strong>{" "}
                    <span className="content-text">
                      As companies focus on reducing their environmental impact,
                      we provide talent skilled in building energy-efficient
                      infrastructures.
                    </span>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div
            className="container text-center p-4"
            data-aos="fade-up"
            data-aos-delay="0"
          >
            <div className="contact-section row justify-content-center align-items-center text-center">
              <div className="col-12 col-md-10 contact-text py-4">
                <h2>Let us help you with your business challenges</h2>
                <p>Contact us to schedule a call or set up a meeting</p>
                <Link href="/contact" className="contact-btn mb-0">
                  Contact us
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
